import { ORPCError } from "@orpc/client";
import { isChunkLoadError } from "@packages/core-client/errors/chunkLoadError.ts";
import { ErrorState } from "@packages/core-client/errors/ErrorState.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useRouteError } from "react-router";
import { i18NextInstanceKey } from "../../../i18n/i18next.ts";
import { PersonNotFound } from "./PersonNotFound.tsx";

export function PersonDetailErrorBoundary() {
    const error = useRouteError();
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("PersonDetailErrorBoundary", { i18n: i18nextInstance });
    const { reset } = useQueryErrorResetBoundary();
    const navigate = useNavigate();

    const handleRetry = useCallback(() => {
        reset();
        void navigate(".", { replace: true });
    }, [reset, navigate]);

    if (error instanceof ORPCError && error.code === "NOT_FOUND") {
        return <PersonNotFound />;
    }

    if (isChunkLoadError(error)) {
        throw error;
    }

    return <ErrorState kind="load" ownsPageTitle title={t("title")} description={t("description")} onRetry={handleRetry} retryLabel={t("retry")} />;
}
